"use client";

import {AiFillCloseCircle, AiOutlinePaperClip} from "react-icons/ai";

interface FileData {
  id: string;
  name: string;
  file: string;
  fileSize: string;
}

interface FileChipProps {
  file: FileData;
  onRemove?: () => void;
  classNames?: string;
}

export function FileChip({file, onRemove, classNames = ""}: FileChipProps) {
  return (
    <div
      className={`mr-2 flex h-[60px] items-center justify-between rounded-xl border border-gray-200 bg-white px-3 py-2 shadow-sm ${
        classNames ? classNames : "w-[155px]"
      }`}
    >
      <a
        href={file.file}
        target="_blank"
        rel="noopener noreferrer"
        className="flex flex-grow items-center space-x-2 overflow-hidden"
        title={file.name}
      >
        <div className="flex h-8 w-8 flex-shrink-0 items-center justify-center">
          <AiOutlinePaperClip className="h-7 w-7 text-yellow-500" />
        </div>
        <div className="flex max-w-[90px] flex-col overflow-hidden">
          <p className="truncate text-sm font-semibold text-black">
            {file.name}
          </p>
          <p className="text-xs text-gray-500">{file.fileSize}</p>
        </div>
      </a>
      {/* Only show remove icon if onRemove is provided */}
      {onRemove && (
        <button
          onClick={onRemove}
          className="ml-2 flex-shrink-0 text-red-500 hover:text-red-600"
          title="Remove"
        >
          <AiFillCloseCircle className="h-6 w-6" />
        </button>
      )}
    </div>
  );
}
